module.exports = __webpack_public_path__ + "static/media/mediahuset.b5c624c0.png";